import React, {Component} from 'react';
import { connect } from "react-redux";

import { updateWheelPrize, updateSpinStatus, wheelSpinning } from '../actions/wheel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDoubleDown } from '@fortawesome/pro-regular-svg-icons';

import './ScrollButtonContainer.css';

class ScrollButtonContainer extends Component{

  constructor(props) {
    super(props);

    this.state = {
      doneSpinning: false,
      startSpinning: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.spinning && this.props.spinning) {
      this.setState({startSpinning: true});
    }

    if (prevProps.spinning && !this.props.spinning) {
      this.setState({doneSpinning: true});
    }
  }

  render() {
    if (this.state.startSpinning) {
      return (
        <a id="scroll-form" className={this.state.doneSpinning?'done-spinning':''} href="#form-container">
          <FontAwesomeIcon icon={faChevronDoubleDown} className="down" />
          <span>
            Click Here or Scroll down to see what you've won!
          </span>
        </a>
      );
    }

    return null;
  }
}

const mapStateToProps = state => ({
  prize: state.s_wheel.prize,
  spinning: state.s_wheel.spinning
});

const mapDispatchToProps = dispatch => ({
  updateWheelPrize: data => {
    dispatch(updateWheelPrize(data));
  },
  updateSpinStatus: data => {
    dispatch(updateSpinStatus(data));
  },
  wheelSpinning: data => {
    dispatch(wheelSpinning(data));
  },
});;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScrollButtonContainer);